import { type SettingState } from './types';

export const initialState: SettingState = {
  theme: 'system',
  currencyFormat: 'full',
  version: 'v1.0.0',
};
